<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {createEventDispatcher } from 'svelte';
import * as m from "@app/paraglide/messages.js";
import { getCopyText } from '@app/lib/copySelection.js';
const dispatch = createEventDispatcher();

const copyEvents = () => {
    try {
        const textToCopy = getCopyText({
            eventGroup: eventGroupState[projectState.selected],
            fallback: "eventText",
        });
        if (textToCopy != null) {
            navigator.clipboard.writeText(textToCopy);
        }
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
    
}
</script>

<a id="btnCopyText"
   role="menuitem"
    aria-label={m.context_menu_copy_text_label()}
   class="dropdown-item" href="#!/"
   onclick={copyEvents}>
    {m.context_menu_copy_text()}
</a>
